<template>
    <b-card class="h-100 sales-ranking-card">
        <div v-if="loading" class="text-center py-4">
            <b-spinner small type="grow"></b-spinner>
        </div>
        <template v-else>
            <div v-if="!embedded" class="text-muted text-uppercase small font-weight-bold">{{ title }}</div>
            <div v-if="subtitle" class="text-muted small mb-1">{{ subtitle }}</div>
            <div class="sales-ranking-card__total" :class="{ 'mt-0': embedded }">${{ numberWithCommas(total) }}</div>

            <div v-if="!rankings.length" class="text-muted small mt-3">No data for this period.</div>
            <div v-else class="sales-ranking-card__list mt-3">
                <component
                    :is="rowHref(row) ? 'a' : 'div'"
                    v-for="row in rankings"
                    :key="(row.sales_rep_id || 'none') + '-' + row.rank"
                    :href="rowHref(row) || undefined"
                    :target="rowHref(row) ? '_blank' : undefined"
                    :rel="rowHref(row) ? 'noopener noreferrer' : undefined"
                    class="sales-ranking-card__row"
                    :class="{ 'sales-ranking-card__row--link': Boolean(rowHref(row)) }"
                >
                    <div class="sales-ranking-card__rank">{{ row.rank }}</div>
                    <div class="sales-ranking-card__meta">
                        <div class="sales-ranking-card__amount">${{ numberWithCommas(row.total) }}</div>
                        <div class="sales-ranking-card__name text-muted">{{ row.sales_rep_name }}</div>
                    </div>
                </component>
            </div>
        </template>
    </b-card>
</template>

<script>
export default {
    name: 'SalesRankingCard',
    props: {
        title: { type: String, required: true },
        subtitle: { type: String, default: '' },
        total: { type: Number, default: 0 },
        rankings: { type: Array, default: () => [] },
        loading: { type: Boolean, default: false },
        embedded: { type: Boolean, default: false },
        rowLinkBuilder: { type: Function, default: null },
    },
    methods: {
        rowHref(row) {
            if (typeof this.rowLinkBuilder !== 'function') {
                return null
            }

            return this.rowLinkBuilder(row) || null
        },
    },
}
</script>

<style scoped>
.sales-ranking-card__total {
    font-size: 1.75rem;
    font-weight: 700;
    line-height: 1.2;
    margin-top: 0.25rem;
}

.sales-ranking-card__row {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.45rem 0;
    border-top: 1px solid rgba(0, 0, 0, 0.06);
    color: inherit;
    text-decoration: none;
}

.sales-ranking-card__row--link {
    cursor: pointer;
    border-radius: 0.25rem;
    margin: 0 -0.35rem;
    padding-left: 0.35rem;
    padding-right: 0.35rem;
    transition: background-color 0.15s ease;
}

.sales-ranking-card__row--link:hover {
    background-color: rgba(0, 123, 255, 0.06);
    text-decoration: none;
    color: inherit;
}

.sales-ranking-card__row--link:hover .sales-ranking-card__name {
    color: #007bff !important;
}

.sales-ranking-card__rank {
    font-size: 1.75rem;
    font-weight: 800;
    line-height: 1;
    min-width: 2rem;
    color: #212529;
}

.sales-ranking-card__amount {
    font-weight: 600;
    line-height: 1.2;
}

.sales-ranking-card__name {
    font-size: 0.85rem;
}
</style>
